<div class="container-fluid m-t-sm" *ngIf="isLoaded()">
  <!-- **************************************************************************************
    FILTROS
   ************************************************************************************** -->
  <div class="row">
    <div class="col-12 m-b-md">
      <p-panel [toggleable]="false" [collapsed]="false">
        <p-header>
          <i class="fa fa-filter" aria-hidden="true"></i> {{ 'ExpenseManagement.filters.title' | translate }}
        </p-header>
        <!-- Contratos: {{contracts.length}} Carpetas de pago: {{executionFolders.length}}-->
        <div class="row" *ngIf="contracts.length > 0">
          <div [ngClass]="{'col-6': executionFolders.length > 0, 'col-12': executionFolders.length === 0}">
            <span class="nav-label">{{ 'ExpenseManagement.filters.contracts' | translate }}</span>
            <div class="form-group">
              <p-dropdown [options]="contracts" autoWidth="false" [style]="{'width':'100%'}"
                [(ngModel)]="selectedContract" (onChange)="filter($event, true, false)"></p-dropdown>
            </div>
          </div>
          <div class="col-6" *ngIf="executionFolders.length > 0">
            <span class="nav-label">{{ 'ExpenseManagement.filters.executionFolders' | translate }}</span>
            <div class="form-group">
              <p-dropdown [options]="executionFolders" autoWidth="false" [style]="{'width':'100%'}"
                [(ngModel)]="selectedExecutionFolders" (onChange)="filter($event,false, true)" [optionLabel]="'label'">
                <ng-template let-option pTemplate="item">
                  <span>
                    <i *ngIf="option?.value !== -1"
                      class="{{ (option?.value?.phase?.identifier | simpleIdentifier) === '40' ? 'far fa-folder-open fa-lg' : 'fas fa-folder fa-lg' }}"></i>
                    {{ option.label }}
                  </span>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <span class="nav-label">{{ 'ExpenseManagement.filters.exercises' | translate }}</span>
            <div class="form-group">
              <p-dropdown [options]="years" [(ngModel)]="selectedYear" autoWidth="false" (onChange)="filter($event)">
              </p-dropdown>
            </div>
          </div>
          <div class="col-3">
            <span class="nav-label">{{ 'ExpenseManagement.filters.classification' | translate }}</span>
            <div class="form-group">
              <p-dropdown [options]="cp" [(ngModel)]="selectedCP" autoWidth="false" (onChange)="filter($event)">
              </p-dropdown>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
  <!-- **************************************************************************************
    DOCUMENTOS
   ************************************************************************************** -->
  <div class="row">
    <div class="col-12 m-b-md">
      <p-panel [toggleable]="false" [collapsed]="false" [style]="'overflow-x:scroll'">
        <p-header class="col-12">
          <span> <i class="fa fa-inbox" aria-hidden="true"></i> {{ 'ExpenseManagement.documentList' | translate }}
          </span>
          <span class="float-right">{{ 'Tasks.showing' | translate }} {{filteredDocuments ? filteredDocuments.length :
            '0'}} de {{documentos?.length}}</span>
        </p-header>
        <div class="row">
          <div class="col-12">
            <p-table [value]="filteredDocuments" [scrollable]="false" responsiveLayout="scroll">
              <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                  <col style="width: 5px">
                  <col style="width: 70px">
                  <col style="width: 68px">
                  <col style="width: 45px">
                  <col style="width: 70px">
                  <col style="width: 100px">
                  <ng-container *ngFor="let phase of phases">
                    <col style="width: 120px">
                  </ng-container>
                  <col style="width: 120px">
                </colgroup>
              </ng-template>
              <ng-template pTemplate="header">
                <tr class="text-center">
                  <th class="status-col"></th>
                  <th class="text-truncate ">{{ 'ExpenseManagement.table.column.exercise' | translate }}</th>
                  <th class="text-truncate">{{ 'ExpenseManagement.table.column.classification' | translate }}</th>
                  <th class="text-truncate ">{{ 'ExpenseManagement.table.column.documentType' | translate }}</th>
                  <th class="text-center text-truncate">{{ 'ExpenseManagement.table.column.date' | translate }}</th>
                  <th class="text-truncate ">{{ 'ExpenseManagement.table.column.state' | translate }}</th>
                  <ng-container *ngFor="let phase of phases">
                    <th class="text-right text-truncate">{{'ExpenseManagement.table.column.' + phase.identifier |
                      translate}}</th>
                  </ng-container>
                  <th class="text-right"> </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-doc>
                <tr>
                  <td [ngClass]="getBgStatusColor (doc)" class="status-col"></td>
                  <td class="text-center">{{doc.exerciseYear}}</td>
                  <td class="text-center">{{this[doc.CP + '_desc']}}</td>
                  <ng-container *ngIf="!doc?.expenseDocument?.captureNumber">
                    <td><span>{{doc['_description']}} </span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="doc?.expenseDocument?.captureNumber">
                    <td>
                      <span *ngIf="doc?.expenseDocument?.referenceNumber " pTooltip="{{'ExpenseDocument.captureNumber'|translate}}  {{': ' + doc?.expenseDocument?.captureNumber}}
                       {{'ExpenseDocument.referenceNumber'|translate}} {{': ' + doc.expenseDocument.referenceNumber}}"
                        tooltipPosition="bottom"> {{doc['_description']}} </span>
                      <span *ngIf="!doc?.expenseDocument?.referenceNumber"
                        pTooltip="{{'ExpenseDocument.captureNumber'|translate}}  {{': ' + doc?.expenseDocument?.captureNumber}}"
                        tooltipPosition="bottom"> {{doc['_description']}} </span>
                    </td>
                  </ng-container>
                  <td class=" text-center">{{doc.documentDTO.creationDate | date: 'dd/MM/yyyy'}}</td>
                  <td class="text-center text-truncate">
                    <span *ngIf="doc.documentDTO && doc.documentDTO.currentState && doc.documentDTO.currentState.type"
                      class="p-1 w-100 text-truncate font-weight-normal" [ngClass]="getTextStatusColor(doc)"
                      data-toggle="tooltip"
                      title="{{doc.documentDTO.currentState.type.description}}">{{doc.documentDTO.currentState.type.description}}</span>
                  </td>
                  <ng-container *ngFor="let phase of phases">
                    <td class="text-right">
                      <span *ngIf="isDocInPhase (doc, phase); else noAmount">{{doc['_amount'] | currency:'EUR'}}</span>
                      <ng-template #noAmount><span>- &euro;</span></ng-template>
                    </td>
                  </ng-container>
                  <td class="text-right">
                    <div class="btn-group">
                      <!--<button disabled="{{isDisabledNewDocument(doc)}}" class="btn  btn-primary btn-sm t-action-button"-->
                      <button *ngIf="isNewDocument(doc)" class="btn  btn-primary btn-sm t-action-button"
                        (click)="newDocument(doc)"
                        title="{{ 'ExpenseManagement.table.column.actions.tooltip.add' | translate}}">
                        <i class="fas fa-plus" aria-hidden="true"></i>
                      </button>
                      <!--<button disabled="{{isDisabledEditDocument(doc)}}" class="btn  btn-primary btn-sm t-action-button" -->
                      <button *ngIf="isEditDocument(doc)" class="btn  btn-primary btn-sm t-action-button"
                        (click)="editDocument(doc)" title="{{ 'General.edit' | translate}}">
                        <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                      </button>
                      <button *ngIf="isShowDocument(doc)" class="btn  btn-primary btn-sm t-action-button"
                        (click)="showDocument(doc)"
                        title="{{ 'ExpenseManagement.actions.showDocument.button' | translate}}">
                        <i class="fas fa-file-invoice" aria-hidden="true"></i>
                      </button>
                      <!--<button disabled="{{isDisabledReverseDocument(doc)}}"-->
                      <button *ngIf="isReversedDocument(doc)" class="btn  btn-primary btn-sm t-action-button"
                        (click)="cancelDocument(doc)" title="{{ 'General.delete' | translate}}">
                        <i class="fas fa-times" aria-hidden="true"></i>
                      </button>
                      <button class="btn  btn-primary btn-sm t-action-button" (click)="openDocument(doc)"
                        title="{{ 'ExpenseManagement.actions.openDocument.button' | translate}}">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="footer" let-columns>
                <tr style="font-weight:bold;    border-width: 0;
                border-style: none;
                border-bottom-width: 1px;
                border-bottom-style: solid;
                border-bottom-color: rgba(0, 0, 0, 0.12);
                height: 35px;">
                  <td class="text-right" colspan="6">{{ 'ExpenseManagement.amount.total' | translate }}</td>
                  <td class="text-right" *ngFor="let phase of phases"> {{getImportePhase (phase, TIPO_IMPORTE_TOTAL) |
                    currency:'EUR'}} </td>
                  <td> </td>
                </tr>
                <tr style="font-weight:bold;border-width: 0;
                border-style: none;
                border-bottom-width: 1px;
                border-bottom-style: solid;
                border-bottom-color: rgba(0, 0, 0, 0.12);
                height: 35px;">
                  <td class="text-right" colspan="6">{{ 'ExpenseManagement.amount.posted' | translate }}</td>
                  <td class="text-right" *ngFor="let phase of phases"> {{getImportePhase (phase, TIPO_IMPORTE_POSTED) |
                    currency:'EUR'}} </td>
                  <td> </td>
                </tr>
                <tr style="font-weight:bold;    border-width: 0;
                border-style: none;
                border-bottom-width: 1px;
                border-bottom-style: solid;
                border-bottom-color: rgba(0, 0, 0, 0.12);
                height: 35px;">
                  <td class="text-right" colspan="6">{{ 'ExpenseManagement.amount.outstanding' | translate }}</td>
                  <td class="text-right" *ngFor="let phase of phases"> {{getImportePhase (phase, TIPO_IMPORTE_PENDING) |
                    currency:'EUR'}} </td>
                  <td> </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>